import React, { useEffect, useState } from 'react';
import AvalancheSubAreasTable from './AvalancheSubAreasTable';
import AvalancheSubAreasEdit from './AvalancheSubAreasEdit';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { debounce } from '@awp/helpers/Utils';
import { AwpContainer } from '../Common/AwpContainer';
import { Permissions, FORM_MODE } from '@awp/constants';
import Authorize from '@awp/components/Authorize';

const MODE = {
  SUB_EDIT: 'subedit',
  SUB_VIEW: 'subview',
  SUB_CREATE: 'subcreate',
};

const AvalancheSubAreasAdmin = ({ subAreas, setSubAreas, avalancheAreaData, mode, setMode, subData, setSubData }) => {
  const [isMedium, setIsMedium] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
  const [isLarge, setIsLarge] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));

  const [search, setSearch] = useState('');

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsMedium(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
      setIsLarge(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));
    }, 100);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const tableProps = {
    avalancheAreaData,
    isMedium,
    isLarge,
    mode,
    setMode,
    setSubData,
    search,
    subAreas,
  };

  const editProps = {
    setMode,
    mode,
    subData,
    subAreas,
    setSubAreas,
    avalancheAreaData,
  };

  return (
    <AwpContainer>
      {(mode === FORM_MODE.EDIT || mode === FORM_MODE.VIEW) && (
        <Authorize requires={[Permissions.ReadAdminTools]}>
          <AvalancheSubAreasTable {...tableProps} />
        </Authorize>
      )}
      {(mode === MODE.SUB_EDIT || mode === MODE.SUB_VIEW || mode === MODE.SUB_CREATE) && (
        <Authorize requires={[Permissions.ReadAdminTools, Permissions.WriteAdminTools]}>
          <AvalancheSubAreasEdit {...editProps} />
        </Authorize>
      )}
    </AwpContainer>
  );
};

export default AvalancheSubAreasAdmin;
